import type { StepConfig } from "@portal/components/multiform/types";
import type { AdminCombinedFormData } from "../../schema";
import { BondAdditionalInfoStep } from "./BondAdditionalInfoStep";
import { BondAdditionalInfoSummary } from "./BondAdditionalInfoSummary";

export const bondAdditionalInfoStepConfig: StepConfig<AdminCombinedFormData> = {
	name: "bondAdditionalInfo",
	label: "Bond Info",
	fieldPaths: ["quote.additionalInfo"],
	component: BondAdditionalInfoStep,
	summaryComponent: BondAdditionalInfoSummary,
};
